export default [
  {
    path: "/chat-settings",
    name: "chat-settings",
    component: () => import("@/views/chatSettings/View.vue"),
    meta: {
      pageTitle: "breadcrumb.chatSettings",
      navActiveLink: "chat-settings",
      resource: "chat-settings",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.chatSettings",
          active: true,
        },
      ],
    },
  },
];
``;
